export default "__VITE_ASSET__mAFtsEO$__"